'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialRssOutline = function IoSocialRssOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.4 26.3c2.4 0 4.4 1.9 4.4 4.3s-2 4.4-4.4 4.4-4.4-2-4.4-4.4 2-4.3 4.4-4.3z m0 7.5c1.7 0 3.1-1.5 3.1-3.2s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.2 3.1 3.2z m-4.4-18.8c10.9 0 20 9.1 20 20h-6.2c0-3.7-1.1-7.3-3.8-10s-6.2-3.7-10-3.7v-6.3z m18.8 18.8c-0.2-2.1-0.7-4.1-1.5-6.1-1-2.2-2.4-4.2-4.1-5.9s-3.7-3.1-5.9-4.1c-2-0.7-4-1.2-6.1-1.4v3.7c4 0.2 7.2 1.7 9.7 4.1s3.9 5.7 4.1 9.7h3.7z m-18.8-28.8c16.6 0 30 13.4 30 30h-6.2c0-13.4-10.4-23.7-23.8-23.7v-6.3z m17.7 12.2c4.4 4.4 7 10.2 7.3 16.6h3.8c-0.7-14.9-12.7-26.9-27.5-27.5v3.7c6.3 0.3 12.1 2.8 16.4 7.2z' })
        )
    );
};

exports.default = IoSocialRssOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-rss-outline.js
// module id = 2948
// module chunks = 168707334958949